export const donationTypeOptions = [
    {
        value: false,
        label: 'Give Once'
    },
    {
        value: true,
        label: 'Monthly'
    }
];

export const donationPaymentType = {
    creditCard: {
        value: "creditCard",
        label: 'Credit card'
    },
    bankAccount: {
        value: "bankAccount",
        label: 'Bank account'
    },
    pledge: {
        value: "pledge",
        label: 'Pledge'
    }
};